module.exports = __webpack_public_path__ + "img/como_lo_hacemos.e3d4c791.jpg";